<template>
  <div class="container">
    <div class="job-list">
      <van-empty v-show="showEmpty">
        暂无投递记录
        <template #image>
          <img class="empty-image" src="../../../assets/images/common/empty.png" alt="no-jobs">
        </template>
      </van-empty>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="jobList.length!==0 ? finishedText : ''"
        :error.sync="error"
        :error-text="errorText"
        loading-text="加载中..."
        @load="onGetMore"
      >
        <div
          v-for="(job, i) in jobList"
          :key="i"
          class="job-card"
          :class="[job.status==='Offline' ? 'job-card-end' : '']"
          @click="toDetail(job.position_id)">
          <div class="top">
            <div class="job-title ellipsis line1">{{job.position_name}}</div>
            <div class="time">
              <div v-if="job.read_flag===true" class="readed-container">
                <div class="dot"></div>
                <span class="readed">已读</span>
              </div>
              {{job.delivery_time | formatDate_}}
            </div>
          </div>
          <div class="labels">
            <div class="label">{{job.work_city}}</div>
            <div class="label">{{ job.education | educationText}}</div>
            <div class="label">{{ job.work_type | workTypeText}}</div>
            <van-tag v-if="job.status==='Online'" class="top-right-content-underway">进行中</van-tag>
            <van-tag v-if="job.status==='Offline'" class="top-right-content-end">停止招聘</van-tag>
          </div>
        </div>
      </van-list>
      <div class="button-wrapper"></div>
      <van-button round type="info" class="find-position" @click="toJobList">寻找合适我的岗位</van-button>
    </div>
  </div>
</template>

<script>
import cookies from "@/libs/util.cookies";
import util from "../../../libs/util";

export default {
  name: "SubmitRecord",
  data() {
    return {
      errorText: "网络开小差了，点击重新加载",
      error: false,
      jobList: [],
      loading: false,
      finished: false,
      listPage: 1,
      user_id: cookies.get("uid"),
    };
  },
  computed: {
    jobType() {
      return this.$route.meta.type;
    },
    showEmpty() {
      return !this.error && !this.loading && this.jobList.length === 0;
    },
    finishedText() {
      return this.jobList.length === 0 ? "" : "— 到底咯！—";
    },
  },
  watch: {},
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    this.getSubmissionList();
  },
  methods: {
    // 获取更多数据
    onGetMore() {
      // 分页更新
      this.listPage += 1;
      this.getSubmissionList();
    },
    getSubmissionList() {
      this.$api
        .POSITION_DELIVERY_LIST({
          user_id: this.user_id,
          admin_flag: false,
          page: this.listPage,
          size: 10,
        })
        .then((res) => {
          this.jobList = this.jobList.concat(res.content);
          // 数据全部加载完成
          if (res.total <= this.listPage * 10) {
            this.finished = true;
          }
          this.error = false;
        })
        .catch(() => {
          this.error = true;
          this.listPage -= 1;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toJobList() {
      this.$router.push("/job/list/social");
    },
    toDetail(jobId) {
      this.$router.push({
        name: "JobDetail",
        params: {
          jobId: jobId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 54px);
  overflow-y: scroll;
  margin-top: 10px;
}

.job-card {
  margin: 0px 20px;
  padding: 13px 0 15px 0;
  border-bottom: 0.5px solid #f1f4f6;
  background: #ffffff;
  border-radius: 4px;
}

.job-card-end {
  opacity: 0.5;
}

.job-card .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.job-card .job-title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin-right: 15px;
}

.job-card .readed-container {
  display: inline-block;
  margin-right: 11px;
}

.job-card .dot {
  width: 4px;
  height: 4px;
  background: #2e5dd2;
  display: inline-block;
  border-radius: 50%;
  line-height: 4px;
  position: relative;
  top: -2px;
}

.job-card .readed {
  font-size: 12px;
  color: #2e5dd2;
  margin-left: 5px;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 17px;
}

.job-card .time {
  color: #999999;
  font-size: 12px;
  min-width: 120px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.job-card .labels {
  display: flex;
}

.job-card .label {
  height: 20px;
  padding: 1px 8px 2px 8px;
  margin-right: 5px;
  font-size: 12px;
  color: #999999;
  background: #f1f4f6;
  border-radius: 4px;
}

.job-card .label:nth-child(1) {
  max-width: 130px;
}

.job-card .top-right-content-underway {
  margin-left: auto;
  width: 52px;
  height: 22px;
  background: linear-gradient(90deg, #ff9900 0%, #ff8d19 24%, #fe6868 100%);
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
}

.job-card .top-right-content-end {
  margin-left: auto;
  width: 64px;
  height: 22px;
  line-height: 23px;
  background: linear-gradient(270deg, #e4e4e4 0%, #f0f0f0 100%);
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  color: #666666;
}

.job-list .button-wrapper {
  width: 375px;
  height: 64px;
  position: fixed;
  bottom: 10px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}

::v-deep {
  .find-position {
    width: 335px;
    height: 44px;
    border-radius: 22px;
    background: linear-gradient(90deg, #3871ff 0%, #2e5dd2 100%);
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 9999;
    font-size: 16px;
    font-weight: bold;
  }

  .van-list__error-text,
  .van-list__finished-text,
  .van-list__loading {
    height: 120px;
  }

  .van-list__finished-text {
    color: #cccccc;
  }
}
</style>

